<template>
  <div>
    {{ $t(object.payment_type) }}
    <div v-if="object.deposit_account && object.deposit_account.title
    && forma === 5
    && !object.family_account"
         class="text-muted small">
      {{ object.deposit_account.title }}
    </div>
    <div class="text-muted small mt-2" v-if="showFamilyAccountDetails">
      <div>{{ $t('from_account') }}: {{ object.relatedFamilyAccountPayment.forma === 5 ? object.relatedFamilyAccountPayment.patient.full_name : object.patient.full_name }}</div>
      <div v-if="object.record && object.record.patient">{{ $t('paid_for') }}: {{ object.record.patient.full_name }}</div>
      <div v-else-if="object.warehouse_operation_id">{{ $t('paid_for') }}: {{ object.relatedFamilyAccountPayment.forma === 5 ? object.patient.full_name : object.relatedFamilyAccountPayment.patient.full_name }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  object: {
    type: Object
  }
})

const forma = computed(() => {
  return Number(props.object.forma)
})

const showFamilyAccountDetails = computed(() => {
  return props.object.family_account
      && props.object.relatedFamilyAccountPayment?.patient
      && props.object.patient
})
</script>
